<script setup lang="ts">
import { version } from './package.json';

useHead({
  title: 'OrthoDGT',
  htmlAttrs: {
    lang: 'en',
  },
});

console.log(`%cversion ${version}`, 'color: white; background: grey; font-size: 22px');
// Use SSR-safe IDs for Headless UI
provideHeadlessUseId(() => useId());

const { $viewport } = useNuxtApp();
const route = useRoute();

const productStore = useProductsStore();
effect(productStore.initProducts);

watch($viewport.breakpoint, (newBreakpoint, oldBreakpoint) => {
  if (Object.keys(route.query).includes('dev')) console.log('Breakpoint updated:', oldBreakpoint, '->', newBreakpoint);
});

const loginLayoutPages = ['login', 'sign-up', 'confirm-email', 'forgot-password', 'check-your-email', 'reset-password-token'];
const panelLayoutPages = ['panel-dashboard', 'panel-order-list', 'panel-order-list-order', 'panel-dashboard-order'];
const userLayoutPages = ['account-dashboard', 'account-delivery', 'account-history', 'account-history-order', 'account-referral'];

const layoutName = computed(() => {
  // console.log(route.name);
  if (String(route.name).startsWith('test')) {
    return 'test';
  }

  if (loginLayoutPages.includes(String(route.name))) return 'login';
  if (userLayoutPages.includes(String(route.name))) return 'account';
  if (panelLayoutPages.includes(String(route.name))) return 'panel';

  return 'default';
});

const dataStore = useDataStore();
const DB = useDbStore();

onMounted(() => {
  if (!Object.values(dataStore.orders).filter(order => order.status === 'precart').length) {
    console.log(11);

    DB.createPrecartOrder();
  }
//   // TODO: after release, remove this code
//   const lastClearTimeStamp = localStorage.getItem('lastClear');
//   if (lastClearTimeStamp) {
//     if (new Date().getTime() - Number(lastClearTimeStamp) > 1000 * 60 * 60 * 24) {
//       // console.log('Clear local storage');
//       localStorage.clear();
//       localStorage.setItem('lastClear', new Date().getTime());
//     }
//   }
//   else {
//     // console.log('Clear local storage');
//     localStorage.clear();
//     localStorage.setItem('lastClear', new Date().getTime());
//   }
});
const containerRef = ref<HTMLElement | null>(null);
const { width } = useElementSize(containerRef);
const padding = useBigLayoutPadding();

watch(width, (newWidth) => {
  let p = 120;
  if (newWidth > 1990 + 240) p = ~~(newWidth - 1990) / 2;
  if (newWidth < 1280) p = 80;
  if (newWidth < 768) p = 16;
  padding.value = p;
}, { immediate: true });
</script>

<template>
  <div ref="containerRef">
    <div
      id="teleports"
      style="position: fixed; z-index: 50; top: 0; left: 0; width: 100dvw; height: 100dvh; pointer-events: none;"
    />
    <NuxtLayout :name="layoutName">
      <!--    <NuxtLayout :name="$device.isMobile ? 'mobile' : 'default'"> -->
      <!--      <NuxtPage /> -->
    </NuxtLayout>
  </div>
</template>

<style lang="css">
  * {
    font-family: 'Red Hat Display', sans-serif;
  }

  svg {
    width: 16px;
    height: 16px;
  }
</style>
